import { useQuery } from '@tanstack/react-query';
import { CommonKey } from '../../types/api';
import sportsApi from '../../utils/sportsApi';
import getUseRightsholderAttribution from '../../utils/getUseRightsholderAttribution';

const getReport = async (client, filters) => {
    if (!filters) return;

    const useRightsholderAttribution = getUseRightsholderAttribution(
        client,
        client.id,
    );

    const query = {
        action: 'fetchQuery',
        domainObject: {
            client: {
                id: client.id,
            },
            ...filters,
            pageSize: 20,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
        },
    };

    const endpoint = `/social-posts`;

    const resp = await sportsApi.url(endpoint).json(query).post().json();
    return resp;
};

export const useSocialPosts = (client, filters) => {
    const useRightsholderAttribution = getUseRightsholderAttribution(
        client,
        client?.id,
    );
    return useQuery({
        queryKey: [CommonKey.SocialPosts, filters, useRightsholderAttribution],
        queryFn: () => getReport(client, filters),
        staleTime: 240000,
    });
};
